import { inject } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { EMPTY, Observable, throwError } from 'rxjs'
import { catchError, switchMap } from 'rxjs/operators'
import Swal from 'sweetalert2'
import { Store } from '@ngrx/store'
import { Router } from '@angular/router'

import { CookieService } from 'ngx-cookie-service'
import { AuthServiceService } from '../new-uaa-services/auth-service.service'
import { removeUser } from '../../app/store/auth.action'
import { removeMenu } from '../../app/store/menu/menu.action'
import {NavigationService} from "../../helper/shared/navigation.service";

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
	const store = inject(Store)
	const router = inject(Router)
	const cookieService = inject(CookieService)
	const authService = inject(AuthServiceService)
	const navigationService = inject(NavigationService)
	req = req.clone({
		withCredentials: true
	})
	return next(req).pipe(
		catchError(error => {
			if (error instanceof HttpErrorResponse) {
				switch (error.status) {
					case 401: {
						if (req.url.includes('refresh') || req.url.includes('/auth/token') ) {
							return next(req)
						}
						return authService.refreshToken().pipe(
							switchMap(() => {
								return next(req)
							}),
							catchError(error => {
								localStorage.clear()
								store.dispatch(removeUser())
								store.dispatch(removeMenu())
								cookieService.set('hasToken', 'false')
								navigationService.clearHistory()
								void router.navigateByUrl('')
								return throwError(() => error)
							})
						)
					}
					case 419: {
						void Swal.fire({
							icon: 'error',
							title: error.error.reason,
							showConfirmButton: false,
							timer: 5000
						})
						return throwError(() => error)
					}
					case 403: {
						void Swal.fire({
							icon: 'error',
							title: 'شما اجازه دسترسی به این فعالیت را ندارید !',
							showConfirmButton: false,
							timer: 5000
						})
						// return EMPTY
						return throwError(() => error)
					}
					case 408: {
						void Swal.fire({
							icon: 'error',
							title: 'شخصی دیگری با این حساب کاربری وارد شده است !',
							text: 'فقط با یک حساب کاربری میتوانید وارد شوید',
							showConfirmButton: false,
							timer: 5000
						})
						store.dispatch(removeUser())
						store.dispatch(removeMenu())
						navigationService.clearHistory()
						cookieService.set('hasToken', 'false')
						localStorage.clear()
						void router.navigateByUrl('')
						return EMPTY
					}
				}
			}

			return throwError(() => error)
		})
	)
}
